import {
  DOMAIN_BY_TYPE_FAILURE,
  DOMAIN_BY_TYPE_SUCCESS,
  DOMAIN_BY_TYPE_REQUEST,
  DOMAIN_SEARCH_RESET_CACHE,
  ALL_DOMAIN_RESULTS_LIMIT,
  FILTERED_DOMAIN_RESULTS_LIMIT,
} from "../../constants";
import { createAction, createErrorAction } from "../../utils";

import unicodeTld from "lib/unicodeTld";

const domainSearchRequest = createAction(DOMAIN_BY_TYPE_REQUEST);
const domainSearchSuccess = createAction(DOMAIN_BY_TYPE_SUCCESS);
const domainSearchFailure = createErrorAction(DOMAIN_BY_TYPE_FAILURE);
const domainSearchResetCache = createAction(DOMAIN_SEARCH_RESET_CACHE);

export const loadDomainsByType = (
  isFullLoad = false,
  type = "popular",
  keyword = false,
) => {
  return async (dispatch, getState, { api }) => {
    const { cart, domains } = getState();
    const keywordInSession = window.localStorage.getItem("keyword");
    const keywordInDOM = document.getElementById("keyword");
    const category = type === "popular" ? "filteredDomains" : "all";

    // No keyword was passed as arg - Check for a keyword in localStorage
    if (!keyword && keywordInSession) {
      keyword = { value: keywordInSession };
    }

    // No keyword in localStorage - Check for a keyword in the DOM
    if (!keyword && keywordInDOM) {
      keyword = { value: keywordInDOM.value };
    }

    // If we still don't have a keyword, find the first domain in the cart and use that
    // as keyword
    if (!keyword && cart.cartItems.length > 0) {
      const firstDomainInCart = cart.cartItems[0];
      if (
        firstDomainInCart.fullDomain &&
        firstDomainInCart.fullDomain !== "nodomain.notld"
      ) {
        const fullDomain = firstDomainInCart.fullDomain;
        keyword = { value: fullDomain.substring(0, fullDomain.indexOf(".")) };
      }
    }

    if (!keyword) {
      dispatch(domainSearchFailure(new Error("No keyword found.")));
      return;
    }

    // Check if we can return a cached result
    // A cached result is a search on the same keyword as the redux state has
    // while also having the type saved.
    // Additionally we check for when then cache was saved
    if (
      keyword.value === domains.keyword &&
      domains[category].hasOwnProperty(type) === true &&
      Date.now() - 60000 < domains.domainsLoadedTimestamp
    ) {
      return;
    }

    // Save keyword in localStorage
    window.localStorage.setItem("keyword", keyword.value);

    // If we have a cache and the keyword changed
    // invalidate the cache
    if (
      Object.keys(domains[category]).length > 0 &&
      keyword.value !== domains.keyword
    ) {
      dispatch(domainSearchResetCache());
    }
    // Load request
    dispatch(domainSearchRequest());

    // API call
    return api
      .getDomainsByType(
        unicodeTld(keyword.value),
        type.toUpperCase(),
        FILTERED_DOMAIN_RESULTS_LIMIT,
      )
      .then(
        (data) => {
          dispatch(
            domainSearchSuccess({
              domains: data.data.domains,
              currency: data.data.currency,
              pagination: data.pagination,
              defaultIncludeVat: data.data.defaultIncludeVat,
              decimalSeparator: data.data.decimalSeparator,
              type: type.toLowerCase(),
              keyword: keyword.value,
            }),
          );

          if (isFullLoad) {
            api
              .getDomainsByType(
                unicodeTld(keyword.value),
                "ALL",
                ALL_DOMAIN_RESULTS_LIMIT,
              )
              .then((data) => {
                dispatch(
                  domainSearchSuccess({
                    domains: data.data.domains,
                    currency: data.data.currency,
                    pagination: data.pagination,
                    defaultIncludeVat: data.data.defaultIncludeVat,
                    decimalSeparator: data.data.decimalSeparator,
                    type: "all",
                    keyword: keyword.value,
                  }),
                );
              });
          }

          return true;
        },
        (err) => {
          dispatch(domainSearchFailure(err));
        },
      );
  };
};
